exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hooper-container[data-v-ebbf145e]{font-size:0.8em;height:100%}@media (min-width: 768px){.hooper-container[data-v-ebbf145e]{width:650px;margin:0 auto}}.hooper-container[data-v-ebbf145e]:focus{outline:none}\n", ""]);

// exports
